import { useModalStore } from '@/shared/lib/store/model/modal.store';

export const VivaModalForm = ({
    title,
    description,
    btnText,
    onOk,
    onClose,
    popupId,
    children,
    classId = 'adminViva',
    btnClass = 'btnShare',
}: {
    title: React.ReactNode;
    description?: React.ReactNode;
    btnText: string;
    onOk: () => void;
    onClose?: () => void;
    popupId: string;
    children?: React.ReactNode;
    classId?: string;
    btnClass?: string;
}) => {
    const { closeModal } = useModalStore();

    return (
        <div id="themePopupWrap">
            <div className="share_pop vivaclass" id={classId}>
                <div className="popWrap">
                    <div className="popup_head">
                        <p className="tit">{title}</p>
                        <a className="popup_close" onClick={() => closeModal(popupId)}>
                            <span className="blind">닫기</span>
                        </a>
                    </div>
                    <div className="popup_body">
                        {description && <p>{description}</p>}
                        {children && children}
                        <div className="btnWrap" onClick={onOk}>
                            <a id="btnShareVivaclassNow" className={btnClass}>
                                {btnText}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
